/**
 * IconXCustom component - Custom X icon for spot comparator.
 */
export function IconXCustom() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <g clipPath="url(#clip0_4540_437)">
        <path d="M18 6L6 18" stroke="#E24239" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 6L18 18" stroke="#E24239" strokeWidth="4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_4540_437">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
